module.exports = __webpack_public_path__ + "static/media/bg.20a94b37.png";